import React from 'react';
import { Typography } from '@mui/material';
import './App.css';

const WindDirectionIndicator = ({ direction, speed, rose }) => {
  const angleInRadians = (direction * Math.PI) / 180;
  const radius = 80; // Radius of the circle
  const circleRadius = 5; // Radius of the inner circle
  const borderwidth = 4; // Width of the border

  const x = radius + radius * Math.sin(angleInRadians) - circleRadius - borderwidth; 
  const y = radius - radius * Math.cos(angleInRadians) - circleRadius - borderwidth;

 
  return (
   
    <div className='wind-direction-container'>
      <div className="wind-direction-indicator">
        <div className="circle">
          <div className="label north">N</div>
          <div className="label east">E</div>
          <div className="label south">S</div>
          <div className="label west">W</div>
          <div 
            className="circle-indicator" 
            style={{
              top: `${y}px`,
              left: `${x}px`,
              width: `${2 * circleRadius}px`, // Set width and height for circle
              height: `${2 * circleRadius}px`,
            }} 
          />
          <div className="center-labels">
            <Typography>
              {speed} km/h
            </Typography>
            <Typography>
              {direction}°
            </Typography>
            <Typography>
              {rose}
            </Typography>           
          </div>
        </div>
      </div>
    </div>
  );
};

export default WindDirectionIndicator;